<template>
    <div>
      <div v-if="!isAuthenticated" class="password-overlay">
      <div class="password-modal">
        <h4 class="mb-3">🔒 Enter Password to View Report</h4>
        <input
          type="password"
          v-model="enteredPassword"
          @keyup.enter="verifyPassword"
          class="form-control mb-3"
          placeholder="Password"
        />
        <button @click="verifyPassword" class="btn btn-primary btn-block">
          Access Report
        </button>

        <p v-if="authError" class="text-danger mt-2">{{ authError }}</p>
      </div>
    </div>
        <div v-if="isLoading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-3 text-muted">Fetching product report data...</p>
        </div>
        <div v-if="!isLoading && isAuthenticated">
            <div class="product-report-page">
    
                <!-- PAGE HEADER -->
                <div class="d-flex justify-content-between align-items-center mb-4">
    <h2 class="page-title">List Affiliate</h2>

    <!-- DOWNLOAD BUTTON -->
    <button class="btn btn-success" @click="downloadCSV">
        ⬇ Download Report (CSV)
    </button>
</div>
    
                <!-- CARD -->
                <div class="report-card p-4">
    
                    <!-- SEARCH + MONTH FILTER -->
                    <div class="d-flex justify-content-between flex-wrap mb-3">
    
                        <input v-model="search" type="text" class="form-control" placeholder="Search..." />
    
    
                        <div>
                            <!-- <select v-model="selectedMonth" class="form-control custom-select mb-3">
              <option v-for="m in months" :key="m" :value="m">{{ m }}</option>
            </select> -->
                        </div>
                    </div>
    
                    <!-- TABLE -->
                    <div class="table-responsive">
                        <table class="table table-border table-hover">
                            <thead class="bg-default">
                                <tr>
    
                                    <th>Agent ID</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone Number</th>
                                    <th>Bank Name</th>
                                    <th>Bank Account</th>
                                   
                                    <th>Total Commision</th>
                                    <th>Total Sales</th>
                                    <th>Month Name</th>
                                    <th>Year</th>
                                </tr>
                            </thead>
    
                            <tbody>
                                <tr v-for="row in paginatedData" :key="row.id">
    
                                    <td>{{ row.AgentCode }}</td>
    
                                    <td>
                                        {{ row.Name }}
                                    </td>
    

                                    <td>
                                        {{ row.Email }}
                                    </td>
    
                                    <td>{{ row.PhoneNumber }}</td>
    
                                    <td>{{ row.BankName }}</td>
                                    <td> {{ row.AccountNumber }}</td>
                                    <td>RM {{ Number(row.MonthlyCommission || 0).toFixed(2) }}</td>
<td>RM {{ Number(row.MonthlySales || 0).toFixed(2) }}</td>
    
<td> {{ row.MonthName }}</td>
<td> {{ row.Year }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
    
                    <!-- PAGINATION -->
                    <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                        <small>
            Showing {{ start + 1 }} to {{ end }} of {{ filteredData.length }} entries
          </small>
    
                        <ul class="pagination mb-0 mt-2">
                            <li class="page-item" :class="{ disabled: page === 1 }" @click="page--">
                                <a class="page-link">‹</a>
                            </li>
    
                            <li class="page-item" v-for="n in totalPages" :key="n" :class="{ active: page === n }" @click="page = n">
                                <a class="page-link">{{ n }}</a>
                            </li>
    
                            <li class="page-item" :class="{ disabled: page === totalPages }" @click="page++">
                                <a class="page-link">›</a>
                            </li>
                        </ul>
                    </div>
                </div>
    
            </div>
        </div>
    </div>
</template>
  
<script>
const ACCESS_PASSWORD = "Flyhigh192077**";
export default {
    name: "ProductReport",

    data() {
        return {
            search: "",
            selectedMonth: "June 2025",
            months: ["June 2025", "May 2025", "April 2025"],

            page: 1,
            perPage: 10,
            selected: [],
            selectAll: false,


            rows: [],
            isLoading: false,

            // Password popup
            isAuthenticated: false,
            enteredPassword: '',
            authError: '',
        };
    },
    async mounted() {
       
        let savedAuth = localStorage.getItem("affiliateReportAuth");

          if (savedAuth === "true") {
              this.isAuthenticated = true;
              this.GetUserBankDetails(); // Auto-load data
              return;
          }

          // Still need login check for app
          let isAuth = await this.UserAuth();
          if (!isAuth) this.GoToLogin();
    },


    computed: {
        filteredData() {
            if (!this.search) return this.rows;

            const s = this.search.toLowerCase();
            return this.rows.filter(item => {
                  const agentMatch =
                      item.AgentCode &&
                      item.AgentCode.toLowerCase().includes(s);

                  const nameMatch =
                      item.Name &&
                      item.Name.toLowerCase().includes(s);

                  const phonematch =
                      item.PhoneNumber &&
                      item.PhoneNumber.toLowerCase().includes(s);
                

                      const emailMatch =
                      item.Email &&
                      item.Email.toLowerCase().includes(s);

                 
                  return agentMatch || nameMatch || phonematch || emailMatch;
              });
        },

        start() {
            return (this.page - 1) * this.perPage;
        },

        end() {
            return Math.min(this.start + this.perPage, this.filteredData.length);
        },

        paginatedData() {
            // This is now safe because 'this.filteredData' is always an array
            return this.filteredData.slice(this.start, this.end);
        },

        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        }
    },

    watch: {
        selected() {
            this.selectAll = this.selected.length === this.rows.length;
        }
    },

    methods: {
        toggleAll() {
            this.selected = this.selectAll ? this.rows.map(r => r.id) : [];
        },
        async GetUserBankDetails() {
            try {
                this.isLoading = true;
                const response = await this.$API.get(this.$GetListAffiliateByAgent);

                if (response.status === 200 && response.data) {
                    this.isLoading = false;
                    this.rows = response.data;



                }

            } catch (err) {
                console.error("Error loading report:", err);
            }
        },
        verifyPassword() {
            this.authError = '';

            if (this.enteredPassword === ACCESS_PASSWORD) {
                this.isAuthenticated = true;
                this.enteredPassword = '';

                // 🔥 Save auth state so refresh won't require re-entering password
                localStorage.setItem("affiliateReportAuth", "true");

            } else {
                this.authError = 'Incorrect password. Please try again.';
            }
        },
        downloadCSV() {
    if (!this.rows || this.rows.length === 0) {
        alert("No data available to download.");
        return;
    }

    // Define CSV headers
    const headers = [
        "Agent ID",
        "Name",
        "Phone Number",
        "Bank Name",
        "Account Number",
        "Email",
        "Total Commission",
        "Total Sales"
    ];

    // Build CSV rows
    const csvRows = this.rows.map(row => [
        row.AgentCode,
        row.Name,
        row.PhoneNumber,
        row.BankName,
        row.AccountNumber,
        row.Email,
        Number(row.MonthlyCommission || 0).toFixed(2),
        Number(row.MonthlySales || 0).toFixed(2)
    ]);

    // Combine header + rows
    const csvContent = [
        headers.join(","), 
        ...csvRows.map(r => r.join(","))
    ].join("\n");

    // Download CSV file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "Affiliate_Report.csv";
    a.click();

    URL.revokeObjectURL(url);
}

    }
};
</script>
  
<style scoped>
.product-report-page {
    background: #f7f7f7;
    min-height: 100vh;
}

.page-title {
    font-weight: 600;
}

.report-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05);
}

.avatar-img {
    width: 38px;
    height: 38px;
    border-radius: 50%;
}

.table thead th {
    color: #6c757d;
    font-weight: 600;
    font-size: 14px;
}

.pagination .page-item.active .page-link {
    background: #2563eb;
    border-color: #2563eb;
    color: #fff;
}

.page-link {
    border-radius: 6px !important;
}

/* --- NEW STYLES FOR PASSWORD POPUP --- */

.password-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
    /* Above other content */
}

.password-modal {
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    width: 100%;
    max-width: 400px;
    text-align: center;
}

.text-danger {
    color: #dc3545;
}

</style>